export default ({ colors, fontFamilies, fontWeights, fontSizes }) => ({
  title: {
    margin: '2rem auto',

    fontSize: fontSizes.bigger,

    color: colors.title
  },

  subtitle: {
    color: colors.subtitle,
    fontSize: fontSizes.normal,
    fontWeight: fontWeights.light
  },

  'contact-id': {
    fontSize: fontSizes.normal,
    fontFamily: fontFamilies.alternate,
    fontWeight: fontWeights.title.default,
    lineHeight: '1.5rem',

    margin: '0',

    color: colors.subtitle
  }
})



// WEBPACK FOOTER //
// ./components/title/styles.js